// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.white-on-hover[data-v-6f294bb6]:hover {
  color: #fff;
}
h3[data-v-6f294bb6] {
  font-size: 1.5rem;
}
.text-clr[data-v-6f294bb6] {
  color: #9c9c9c;
}
.style-box[data-v-6f294bb6] {
  background: #fff;
  display: inline-block;
  width: 100%;
  padding: 20px 20px;
  font-size: 0.9rem;
  text-decoration: none;
  color: #9c9c9c;
  box-shadow: 0 0rem 16px rgb(0 0 0 / 7%);
}
.style-box[data-v-6f294bb6]:hover {
  text-decoration: none;
}
.selection-bar[data-v-6f294bb6] {
  font-size: 1.6rem;
  padding: 10px 5px;
}
.next-btn[data-v-6f294bb6]:hover {
  text-decoration: none;
  color: #fff;
}
.checkradio[data-v-6f294bb6] {
  position: absolute;
  top: 20px;
  left: 25px;
  height: 20px;
  width: 20px;
  border: 3px solid #eee;
  border-radius: 50%;
  cursor: pointer;
}
.selected-box-border[data-v-6f294bb6] {
  background: #f2f2f2;
  color: #000;
  font-weight: bold;
  box-shadow: none;
}
.selected-box-border .text-clr[data-v-6f294bb6] {
  color: #000;
}
.selected-radio-btn[data-v-6f294bb6] {
  height: 20px;
  width: 20px;
  position: absolute;
  left: 0px;
  top: 0px;
  border-radius: 50%;
}
.outer-span[data-v-6f294bb6] {
  height: 20px;
  width: 20px;
  position: absolute;
  left: 30px;
  top: 35%;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
}
.outer-span span[data-v-6f294bb6] {
  top: 3px;
  left: 4px;
  height: 10px;
  width: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/KellyBlueBook/KbbTrimSelect/KbbTrimSelect.vue"],"names":[],"mappings":";AA6CA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,uCAAuC;AACzC;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;AACb","sourcesContent":["<template>\r\n  <div>\r\n    <div class=\"mb-2 pb-5\">\r\n      <div class=\"selection-bar pb-5 text-center\">What is the style of your vehicle?</div>\r\n\r\n      <div>\r\n        <div class=\"row\">\r\n          <div\r\n            v-for=\"trim in kbbMoreVehicles\"\r\n            :key=\"trim.trimId\"\r\n            class=\"col-md-6 my-2 cursor-pointer\"\r\n          >\r\n            <div\r\n              class=\"style-box\"\r\n              :class=\"{\r\n                'color-primary selected-box-border': selectedTrim === trim.trimId,\r\n              }\"\r\n              @click.prevent=\"onTrimSelect(trim)\"\r\n            >\r\n              <span class=\"outer-span\">\r\n                <span\r\n                  v-if=\"selectedTrim === trim.trimId\"\r\n                  class=\"bgcolor-primary vin selected-radio-btn\"\r\n                />\r\n              </span>\r\n              <span class=\"ml-4 text-clr\">{{ trim.trimName }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"text-center\">\r\n        <a\r\n          class=\"cursor-pointer bgcolor-primary color-white px-5 py-3 rounded-buttons my-4 d-inline-block no-hover white-on-hover\"\r\n          @click.prevent=\"onContinueClick()\"\r\n        >\r\n          <span>Continue </span>\r\n          <em class=\"primaryicon-longarrow-right\" />\r\n        </a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</template>\r\n<script type=\"text/javascript\" src=\"./KbbTrimSelect.js\"></script>\r\n<style scoped>\r\n.white-on-hover:hover {\r\n  color: #fff;\r\n}\r\nh3 {\r\n  font-size: 1.5rem;\r\n}\r\n.text-clr {\r\n  color: #9c9c9c;\r\n}\r\n.style-box {\r\n  background: #fff;\r\n  display: inline-block;\r\n  width: 100%;\r\n  padding: 20px 20px;\r\n  font-size: 0.9rem;\r\n  text-decoration: none;\r\n  color: #9c9c9c;\r\n  box-shadow: 0 0rem 16px rgb(0 0 0 / 7%);\r\n}\r\n\r\n.style-box:hover {\r\n  text-decoration: none;\r\n}\r\n.selection-bar {\r\n  font-size: 1.6rem;\r\n  padding: 10px 5px;\r\n}\r\n.next-btn:hover {\r\n  text-decoration: none;\r\n  color: #fff;\r\n}\r\n.checkradio {\r\n  position: absolute;\r\n  top: 20px;\r\n  left: 25px;\r\n  height: 20px;\r\n  width: 20px;\r\n  border: 3px solid #eee;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n.selected-box-border {\r\n  background: #f2f2f2;\r\n  color: #000;\r\n  font-weight: bold;\r\n  box-shadow: none;\r\n}\r\n.selected-box-border .text-clr {\r\n  color: #000;\r\n}\r\n.selected-radio-btn {\r\n  height: 20px;\r\n  width: 20px;\r\n  position: absolute;\r\n  left: 0px;\r\n  top: 0px;\r\n  border-radius: 50%;\r\n}\r\n.outer-span {\r\n  height: 20px;\r\n  width: 20px;\r\n  position: absolute;\r\n  left: 30px;\r\n  top: 35%;\r\n  border-radius: 50%;\r\n  border: 1px solid #e6e6e6;\r\n}\r\n.outer-span span {\r\n  top: 3px;\r\n  left: 4px;\r\n  height: 10px;\r\n  width: 10px;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
